import { Badge, Group, Text } from "@mantine/core";
import StatusText from "../../../common/components/DataTable/StatusText";
import { formatAmount, formatPolicyDate, getJourneyInfo } from "./allPolicyHelpers";
import PolicyCellStack from "./PolicyCellStack";

const journeyPhaseStyle = (phase) => {
  if (phase === "ACTIVE") return { bg: "#D1FFD9", c: "#24CB3F" };
  if (phase === "EXPIRED") return { bg: "#FFE1D8", c: "#FF8A00" };
  return { bg: "#FFF4D6", c: "#E67700" };
};

export const JourneyColumn = ({ row }) => {
  const journey = getJourneyInfo(row);
  const phaseStyle = journeyPhaseStyle(journey.phase);
  return (
    <PolicyCellStack>
      <Text fw={600} size="sm" lineClamp={1}>
        {row.traveller_from_name || "—"} - {row.traveller_to_name || "—"}
      </Text>
      <Text size="xs" c="dimmed">
        {formatPolicyDate(row.coverage_start_date)} - {formatPolicyDate(row.coverage_end_date)}
      </Text>
      <Group gap={6} wrap="wrap">
        <Text size="xs" c="dimmed">{journey.duration}</Text>
        <Badge
          size="xs"
          variant="light"
          styles={{
            root: { background: phaseStyle.bg, color: phaseStyle.c },
            label: { color: phaseStyle.c, fontWeight: 700 },
          }}
        >
          {journey.phase}
        </Badge>
        {journey.hint ? (
          <Text size="xs" c={journey.phase === "ACTIVE" ? "teal" : "orange"} fw={600}>
            {journey.hint}
          </Text>
        ) : null}
      </Group>
    </PolicyCellStack>
  );
};

export const StatusColumn = ({ row }) => (
  <div style={{ padding: "12px 0" }}>
    <StatusText status={row.status} field="status" />
  </div>
);

export const AmountColumn = ({ row }) => (
  <Text fw={700} size="sm" py="sm">
    {formatAmount(row.currency, row.total_amount)}
  </Text>
);

export const CreatedColumn = ({ row, value }) => (
  <Text size="sm" c="dimmed" py="sm">
    {formatPolicyDate(value ?? row.created_on)}
  </Text>
);
